// extracted by mini-css-extract-plugin
export default {"root":"LimitedAccessBanner_root__gWKB9","text":"LimitedAccessBanner_text__zDBY+","button":"LimitedAccessBanner_button__hWxD0"};